module.exports = __webpack_public_path__ + "img/集团产品.b64cb1e3.jpg";